import { API_URL } from '../constants';

const V1_URL = `${API_URL}/v1/users`;

export const FORGOT_PASSWORD_BACKOFFICE = `${V1_URL}/forgot_password_backoffice`;
